import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.fileExtensionMapping = {
      pdf: 'pdf',
      xlsx: 'xls',
      xsx: 'xls',
      doc: 'document',
      docx: 'document',
      txt: 'txt',
      csv: 'csv',
      mp4: 'mp4'
    };
  }
  getFileIcon() {
    if (this.src) {
      const extenstion = this.src.split('.').pop();
      if (extenstion && extenstion in this.fileExtensionMapping) {
        return this.fileExtensionMapping[extenstion];
      }
    }
    return 'error';
  }
};
__decorate([Prop()], default_1.prototype, "src", void 0);
__decorate([Prop({
  default: null
})], default_1.prototype, "shape", void 0);
__decorate([Prop({
  default: null
})], default_1.prototype, "fit", void 0);
__decorate([Prop({
  default: null
})], default_1.prototype, "size", void 0);
default_1 = __decorate([Component({
  name: 'Thumb'
})], default_1);
export default default_1;